export enum RequiredActionInfoType {
    pendingReviewPerJob = 'pendingReviewPerJob',
    pendingReviewCandidate = 'pendingReviewCandidate',
    notContactedCandidatesPerJob = 'notContactedCandidatesPerJob',
    requireResponseCandidateTotal = 'requireResponseCandidateTotal',
    requireResponseCandidatePerJob = 'requireResponseCandidatePerJob',
}
